import API from '../index';
import { Coupon } from '../../types/payment';

const getAvailableCoupons = async (shipmentRef: string): Promise<Coupon[]> => {
  const { resources } = await API.post('/transaction/available-coupons', { shipmentRef });
  return resources;
};

export default getAvailableCoupons;
